import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { MdOutlineEdit } from "react-icons/md";
import { IoAdd } from "react-icons/io5";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import swal from "sweetalert2";
import { set } from "date-fns";
const EditSkill = () => {

  const [showModal, setShowModal] = useState(false);
  const [isSkillOpen, setIsSkillopen] = useState(false);
  const [skillid, setSkillid] = useState("");   
  const [skill_id, setSkill_id] = useState(""); 
  const [checkedSkills, setCheckedSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [skills, setSkills] = useState([]);
  const [followSkill, setFollowSkill] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState([]);
  const [selectedEducation, setSelectedEducation] = useState([]);
  const [experience, setExperience] = useState([]);
  const [education, setEducation] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const skillsRef = useRef([]);
  const inputRef = useRef(null);
  const eduRef = useRef(null);
  const expRef = useRef(null);
  const [skillValue, setSkillValue] = useState("");
  const [skillerror, setskillError] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [filteredSkills, setFilteredSkills] = useState([skillsRef.current]);
  const [skilldata, setSkilldata] = useState([]);
  const skillopenModal = () => {
    setIsSkillopen(true);
  };
  const skillcloseModal = () => {
    setIsSkillopen(false);
  };
  const handleInputChange = (event) => {
    const input = event.target.value;
    setInputValue(input);
    setskillError({ inputValue: "" });
    if (input.trim() === "") {
      setFilteredSkills(skillsRef.current.skill_name);
    } else {
      const filtered = skillsRef.current?.filter((skill) =>
        skill.skill_name.toLowerCase().includes(input.toLowerCase())
      );
      setFilteredSkills([input, ...filtered]);
    }

    setIsDropdownOpen(true);
  };
  const handleSelectSkill = (skill_id, skill_name) => {
    setSkillValue(skill_id);
    setInputValue(skill_name);
    setIsDropdownOpen(false);
    setSelectedExperience([]);
    setSelectedEducation([]);
    setFollowSkill(false);
  };
  const handleExperienceChange = (expId) => {
    console.log(selectedExperience, "expId");
    setSelectedExperience((prev) =>
      prev.includes(expId)
        ? prev.filter((id) => id !== expId)
        : [...prev, expId]
    );
  };
  const handleEducationChange = (eduId) => {
    setSelectedEducation((prev) =>
      prev.includes(eduId)
        ? prev.filter((id) => id !== eduId)
        : [...prev, eduId]
    );
  };

    
  const getProfileData = async (id) => {
    try {
      const response = await axios.get(BaseUrl + `users`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      const response2 = await axios.get(BaseUrl + "skills");
      skillsRef.current = response2.data;
      setSkills(response2.data);
      setFilteredSkills(response2.data);
      setSkilldata(response.data.data.userskill);
      const schools = response.data.data.education.map((edu) => ({
        id: edu.id,
        name: edu.school,
      }));

      const experience = response.data.data.experience.map((exp) => ({
        id: exp.id,
        name: exp.company,
      }));
      setExperience(experience);
      eduRef.current = schools;
      expRef.current = experience;
      setEducation(eduRef.current);

    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const id = Cookies.get("userId");
    console.log(id);
    getProfileData(id);
  }, []);

  const validateSkillForm = () => {
    let result = true;
    let errors = {};
    if (inputValue === "") {
      errors.inputValue = "Please enter your skill";
      result = false;
    }
    setskillError(errors);
    return result;
  };
  const handleskillfromsubmit = async (e) => {
    e.preventDefault();
    const result = validateSkillForm();
    const skillData = {
      skill_id: skillValue?skillValue:skill_id,
      experience_ids: selectedExperience,
      education_ids: selectedEducation,
      follow_skill: followSkill,
    };
    console.log(skillData,"skilldata");
    const id = Cookies.get("userId");
    if (result) {
      try {
        const response = await axios.post(
          BaseUrl + `users/editSkill`,
          skillData,
          {headers: { Authorization: `Bearer ${Cookies.get("token")}` }}
        );

        if (response.status === 200) {
          getProfileData(Cookies.get("userId"));
          setIsSkillopen(false);
          setInputValue("");
          
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const handledeleteskill = async (e, id) => {
    e.preventDefault();
    const result = await swal.fire({
      title: "Are you sure?",
      text: "You want to delete this experience?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    console.log(result);
    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          BaseUrl + `users/deleteSkill/${id}`
        );
        if (response.status === 200) {
          setIsSkillopen(false);
          getProfileData(Cookies.get("userId"));
          swal.fire("Deleted!", "Your experience has been deleted.", "success");
        }
      } catch (error) {
        console.log(error);
        swal.fire("Error!", "Something went wrong. Please try again.", "error");
      }
    }
  };
  return (
    <div className="bg-[#F3F2EF] mt-14">
      <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
        <div className="w-full lg:w-3/4 ">
          <div className="flex flex-col  bg-white w-full border border-gray-300 rounded-md  py-4">
            <div className="flex  justify-between items-center px-4">
              <div className="flex space-x-8 ">
                <div className="text-2xl">
                  <Link to={"/user/userprofile"}>
                    <FaArrowLeftLong />
                  </Link>
                </div>
                <div>
                  <p className="text-xl">Skills</p>
                </div>
              </div>
              {/* <div className="text-3xl text-gray-500 hover:text-black hover:bg-gray-200 rounded-full p-1">
                <IoAdd />
              </div> */}
            </div>
            <div className="mt-4">
              {skilldata.map((skill, index) => (
                <div className="flex justify-between items-center bg-white  my-2 py-2 px-4 border-b border-gray-200">
                  <div className="flex space-x-4">
                    <img
                      src="https://placehold.co/50x50"
                      alt="Company logo"
                      className="w-12 h-12 object-cover rounded-full"
                    />
                    <div>
                      <h3 className="text-lg font-medium">
                        {skill.skill_name}
                      </h3>
                      {skill.experience.length > 0 ? (
                        <p className="text-gray-600">
                          {skill.experience.slice(0, 2).map((exp, expIndex) => (
                            <span key={expIndex}>
                              {exp.name} at {exp.company}
                              {expIndex !== skill.experience.length - 1 && (
                                <br />
                              )}
                            </span>
                          ))}
                        </p>
                      ) : (
                        <p className="text-gray-600">No experience available</p>
                      )}
                    </div>
                  </div>
                  <div>
                    <button
                      className="text-2xl text-gray-500 hover:text-black hover:bg-gray-200 rounded-full p-2"
                      onClick={() => {
                        if (skilldata && skill) {
                          skillopenModal();
                          setSkillid(skill.id);
                          setSkill_id(skill.skill_id);
                          setInputValue(skill.skill_name);
                          setExperience(skill.experience);
                          setEducation(skill.education);
                          setFollowSkill(skill.follow_skill);
                          setSelectedEducation(skill.education_ids.split(",").map(Number) || []);
                          setSelectedExperience(skill.experience_ids.split(",").map(Number) || []);
                        } else {
                          console.error(
                            "Invalid experience data:",
                            skilldata,
                            skill
                          );
                        }
                      }}
                    >
                      <MdOutlineEdit />
                    </button>
                  </div>
                  {isSkillOpen && (
                    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10 ">
                      <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                        <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                          <h2 className="text-xl font-semibold">Edit Skill</h2>
                          <button
                            onClick={skillcloseModal}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        <form>
                          <div className="py-4 px-8 overflow-y-auto max-h-[500px]">
                            <p className="text-red-500 text-sm mb-6">
                              * Indicates required
                            </p>

                            <div className="mb-6" ref={inputRef}>
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                Skill <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                onFocus={() => setIsDropdownOpen(true)}
                                className="w-full border-b-2 border-black rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-600 focus:border-blue-600 sm:text-sm"
                                placeholder="Type to search or add a skill..."
                              />
                              <span className="text-red-500 text-sm">
                                {skillerror.inputValue}
                              </span>
                              {isDropdownOpen && (
                                <ul className=" bg-white border border-gray-300 rounded-md mt-1 shadow-lg z-10 max-h-48 overflow-y-auto">
                                  {filteredSkills?.map((skill, index) => (
                                    <li
                                      key={index}
                                      onClick={() =>
                                        handleSelectSkill(
                                          skill.skill_id,
                                          skill.skill_name
                                        )
                                      }
                                      className="px-3 py-2 cursor-pointer hover:bg-blue-100"
                                    >
                                      {skill.skill_name}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                            {inputValue && (
                              <div className="mb-6">
                                <h1 className="text-lg font-medium">
                                  Show us where you used this skill
                                </h1>
                                <p className="text-[12px] text-gray-600 mb-6">
                                  75% of hirers value skill context. Select at
                                  least one item to show where you used this
                                  skill.
                                </p>

                                {expRef.current?.length > 0 && (
                                  <div className="mb-4">
                                    <h2 className="text-sm font-medium text-gray-400 mb-4">
                                      Experience
                                    </h2>
                                    {expRef.current.map((exp) => (
                                      <div
                                        key={exp.id}
                                        className="flex items-center mb-6"
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedExperience.includes(
                                            exp.id
                                          )}
                                          onChange={() =>
                                            handleExperienceChange(exp.id)
                                          }
                                          className="form-checkbox h-5 w-5 text-blue-600"
                                        />
                                        <label className="ml-2 text-md">
                                          {exp.name}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {eduRef.current?.length > 0 && (
                                  <div className="mb-4">
                                    <h2 className="text-sm font-medium text-gray-400 mb-4">
                                      Education
                                    </h2>
                                    {eduRef.current.map((edu) => (
                                      <div
                                        key={edu.id}
                                        className="flex items-center mb-6"
                                      >
                                        <input
                                          type="checkbox"
                                          checked={selectedEducation.includes(
                                            edu.id
                                          )}
                                          onChange={() =>
                                            handleEducationChange(edu.id)
                                          }
                                          className="form-checkbox h-5 w-5 text-blue-600"
                                        />
                                        <label className="ml-2 text-md">
                                          {edu.name}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                <div>
                                  <div className="flex items-center">
                                    <input
                                      type="checkbox"
                                      className="form-checkbox h-5 w-5 text-blue-600"
                                      checked={followSkill}
                                      onChange={() =>
                                        setFollowSkill((prev) => !prev)
                                      }
                                    />
                                    <label className="ml-2 text-md">
                                      Follow this skill to keep up with relevant
                                      content.
                                    </label>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="flex justify-between border-t-[1px] border-gray-200 py-4 px-8 ">
                            <button
                              type="submit"
                              className="bg-white text-gray-700 hover:bg-gray-100 px-6 py-2 rounded-lg"
                              onClick={(e) => handledeleteskill(e, skillid)}
                            >
                              Delete Experience
                            </button>
                            <button
                              type="submit"
                              className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                              onClick={(e) =>
                                handleskillfromsubmit(e, skillid)
                              }
                            >
                              Save
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/4">
          <div className="bg-white w-full border border-gray-300 rounded-md">
            <img
              src="https://placehold.co/200x200"
              alt="Profile picture"
              className="w-full h-48 object-cover rounded-t-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSkill;
